module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Splash */
(function(fox) {
	'use strict';
	
	fox.registerWidget('Layout_Splash', {
		configure: function () {
			this.registerOptions('', {
				'widgets.footer.widget': 'Site_Footer'
			})
		
			this.callParent('configure', arguments);
		}

	}, 'Site_Layout');
	
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/layout/splash.js
// module id = 856
// module chunks = 4